<template>
  <v-data-table
    :headers="headers"
    :items="itemsWithLoading"
    :disable-pagination="true"
    :disable-sort="true"
    :loading="isLoading"
    loading-text="Loading... please wait"
    class="elevation-1 container"
    hide-default-footer
    >

    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="createItem">New Item</v-btn>
      </v-toolbar>
    </template>

    <template v-slot:item.action="props">
      <v-icon
        small
        @click="deleteItem(props.item.id)"
      >
        delete
      </v-icon>

      <v-icon
        small
        @click="upItem(props.item.id)"
      >
        mdi-arrow-up-bold
      </v-icon>

      <v-icon
        small
        @click="downItem(props.item.id)"
      >
        mdi-arrow-down-bold
      </v-icon>
    </template>

    <template v-slot:item.name="props">
      <v-edit-dialog
        :return-value.sync="props.item.name"
        @save="updateItem('name', props.item.name, props.item.id)"
        >
        <span :class='{ "default-value": props.item.name == ""}'>
          {{ props.item.name | placeholder("Click here to modify the name") }}
        </span>
        <template v-slot:input>
          <v-text-field
            v-model="props.item.name"
            single-line
            ></v-text-field>
        </template>
      </v-edit-dialog>
    </template>

    <template v-slot:item.quantity="props">
      <v-edit-dialog
        :return-value.sync="props.item.quantity"
        @save="updateItem('quantity', props.item.quantity, props.item.id)"
        > {{ props.item.quantity }}
        <template v-slot:input>
          <v-text-field
            v-model="props.item.quantity"
            type="number"
            single-line
            ></v-text-field>
        </template>
      </v-edit-dialog>
    </template>

  </v-data-table>
</template>

<script>
export default {
  name: 'ItemList',
  data () {
    return {
      headers: [],
      defaultHeaders: [
        { text: 'Quantity', value: 'quantity' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'action' }
      ],
    }
  },
  computed: {
    itemsById: function() {
      let itemsById = {}
      for (let item in this.items) {
        itemsById[this.items[item].id] = this.items[item]
      }
      return itemsById
    },
    itemsId: function() {
      let itemsId = []
      for (let item in this.items) {
          itemsId.push(this.items[item].id)
      }
      return itemsId
    },
    itemsWithLoading: function() {
      if (this.isLoading)
        return []
      else
        return this.items
    },
  },
  props: {
    items: Array,
    listId: String,
    isLoading: Boolean
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.headers = []
      } else {
        this.headers = this.defaultHeaders
      }
    },
  },
  methods: {
    createItem () {
      this.$emit('loading')
      this.$http.put(
        `https://api.shoplist.peuvrel.net/list/${this.listId}/item`
      ).then((response) => {
        this.items.push(JSON.parse(response.data.data))
        this.$emit('refresh-list')
      });
    },

    updateItem (property, newProperty, itemId) {
      const item = this.itemsById[itemId]

      let form = new FormData();
      form.set('data', `{"${property}": "${newProperty}"}`)

      this.$http.post(
        `https://api.shoplist.peuvrel.net/list/${this.listId}/item/${item.id}`,
        form
      )
    },

    deleteItem (itemId) {
      this.$emit('loading')
      this.$http.delete(
        `https://api.shoplist.peuvrel.net/list/${this.listId}/item/${itemId}`
      ).then(() => {
        this.$emit('refresh-list')
      })
    },

    upItem (itemId) {
      this.moveItem(itemId, false)
    },

    downItem (itemId) {
      this.moveItem(itemId, true)
    },

    moveItem (itemId, goDown) {
      this.$emit('loading')
      const itemIndex = this.itemsId.findIndex((element) => element == itemId)

      if (itemIndex == goDown ? this.itemsId.length - 1 : 0) {
        // Already first/last element
        return true
      }

      let items = []

      if (goDown) {
        items = this.itemsId.slice(0, itemIndex)
          .concat(this.itemsId[itemIndex + 1])
          .concat(itemId)
          .concat(this.itemsId.slice(itemIndex + 2))
      } else {
        items = this.itemsId.slice(0, itemIndex - 1)
          .concat(itemId)
          .concat(this.itemsId[itemIndex - 1])
          .concat(this.itemsId.slice(itemIndex + 1))
      }

      items = items.map(x => '"' + x + '"')

      let form = new FormData();
      form.set('data', `{"items": [${items}]}`)

      this.$http.post(
        `https://api.shoplist.peuvrel.net/list/${this.listId}`,
        form
      ).then(() => {
        this.$emit('refresh-list')
      })
    },
  },
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}

.default-value {
    color: grey;
    font-style: italic;
}
</style>
